import { Box, Stack, Typography } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchLectureIntroduce } from '@/api/vx';
import { cleanHtml } from '@/api/util';

export default function IntroductionTab() {
  const { isMobile } = useIsMobile()
  const { id } = useParams();
  const [introData, setIntroData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const fetchIntro = async () => {
        if (!id) {
          setLoading(false);
          return;
        }
        setLoading(true);
        try {
          const response = await fetchLectureIntroduce({ params: { eduLectureId: id } });
          setIntroData(response.data);
        } catch (error) {
          console.error("Failed to fetch introduction data:", error);
          setIntroData(null);
        } finally {
          setLoading(false);
        }
      };
      fetchIntro();
    }, [id]);

  const renderSection = ({ title, list, paragraphs, mb = 3 }) => {
    return (
      <Stack
        spacing={1}
        sx={{ 
          mb
        }}
      >
        {/* 제목 */}
        <Typography fontWeight={600}>{title}</Typography>

        {/* 리스트 */}
        {list?.length > 0 && (
          <Stack
            component="ul"
            sx={{
              pl: 2,
              '& li::marker': {
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                bgcolor: 'grey.600'
              },
            }}
          >
            {list.map((item, idx) => (
              <Typography
                component="li"
                key={idx}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        )}

        {/* 본문 */}
        {Array.isArray(paragraphs)
          ? paragraphs.map((text, idx) => (
              <Typography
                key={idx}
                sx={{ whiteSpace: 'pre-line' }}
              >
                {text}
              </Typography>
            ))
          : (
            <Typography
              sx={{ whiteSpace: 'pre-line' }}
            >
              {paragraphs}
            </Typography>
          )}
      </Stack>
    )
  }

  return (
    <>
      <Box
        sx={{
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 7,
          pt: 1,
          px: isMobile ? 0 : 3,
        }}
      >
        {renderSection({
          title: '과정소개',
          paragraphs: [<Box dangerouslySetInnerHTML={{ __html: cleanHtml(introData?.eduIntroduce) }} /> || ''],
        })}

        {renderSection({
          title: '과정특징',
          paragraphs: <Box dangerouslySetInnerHTML={{ __html: cleanHtml(introData?.cuationMetters1) }} /> || '',
        })}

        {renderSection({
          title: '학습대상',
          paragraphs: introData?.eduTgNop || '',
        })}

        {renderSection({
          title: '강사소개',
          paragraphs: introData?.lecturerName || '',
          mb: 0,
        })}
      </Box>
    </>
  )
}
